import ComingSoonWrapper from '../components/ComingSoonComponent/ComingSoon';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const ComingSoonPage = ({hideLanguageSwitcherSetter, hideHeaderFooterSetter}) => {
  const seo = usePageSEO('comingSoon');

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        type={seo.type}
        noIndex={seo.noIndex}
        noFollow={seo.noFollow}
      />
      <ComingSoonWrapper hideHeaderFooterSetter={hideHeaderFooterSetter} hideLanguageSwitcherSetter={hideLanguageSwitcherSetter}/>
    </>
  );
};

export default ComingSoonPage;